export enum InputTypes {
    Question = 1,
    CalculationVariable = 2,
    RangeVariable = 3,
    SingleLookupVariable = 4,
    DoubleLookupVariable = 5,
    StaticLookupVariable = 6,
    MultiplyVariable = 7,
}

export const InputTypesLabels = new Map<number, string>([
    [InputTypes.Question, "Question"],
    [InputTypes.CalculationVariable, "Custom Calculation"],
    [InputTypes.RangeVariable, "Range Lookup"],
    [InputTypes.SingleLookupVariable, "Single Lookup"],
    [InputTypes.DoubleLookupVariable, "Double Lookup"],
    [InputTypes.StaticLookupVariable, "Static Lookup"],
    [InputTypes.MultiplyVariable, "Multiply Variable"]
]);
